import { render, staticRenderFns } from "./HbList.vue?vue&type=template&id=50245e2e&"
import script from "./HbList.vue?vue&type=script&lang=js&"
export * from "./HbList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports